const render = require('./lib/render');
const compile = require('./lib/compile');

exports.render = render;
exports.compile = compile;
